import React from 'react';
import PropTypes from 'prop-types';

const FormGroup = ({ children, className }) => (
  <div className={`form-group ${className}`}>
    {children}
  </div>
);

FormGroup.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

FormGroup.defaultProps = {
  className: '',
};

export default FormGroup;
